import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { customerLogin } from '../services/api';
import { useCustomerAuth } from '../services/CustomerAuthContext';

function CustomerLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginCustomer } = useCustomerAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await customerLogin(form);
      loginCustomer(data.token, data.customer);
      navigate('/commissions');
    } catch (err) {
      setError(err.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page customer-auth">
      <div className="auth-card">
        <span className="auth-badge">Customer</span>
        <h2>Customer Sign In</h2>
        <p className="auth-subtitle">Access your commissions and bids</p>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          <input type="password" placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p className="auth-link">Don't have an account? <Link to="/customer/register">Register</Link></p>
        <p className="auth-link"><Link to="/forgot-password">Forgot password?</Link></p>
        <p className="auth-link">Are you a vendor? <Link to="/vendor/login">Vendor sign in</Link></p>
      </div>
    </div>
  );
}

export default CustomerLogin;
